export type WithoutId<T> = Omit<T, 'id'>;

export const isWithId = <T, K extends { id: string }>(value: T | K): value is K => {
  return (value as K).id !== undefined;
};
